// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles-" + {"294":"990b5f6cf50085c2d9a5","846":"328251a20f477e9b26ef"}[chunkId] + ".css";
};